export const ACR_SWITCH_OPTIONS = {
  enabled: [
    { label: 'Enabled', value: 'enabled' },
    { label: 'Disable', value: 'disabled' }
  ],
  disabled: [
    { label: 'Enable', value: 'enabled' },
    { label: 'Disabled', value: 'disabled' }
  ]
}
